import { useMemo } from 'react';
import { Chip } from '@material-ui/core';
import { StockInfo } from '@setvi/shared/interfaces';

const ExternalChip = ({
  stockInfo,
  disabled
}: {
  stockInfo: StockInfo;
  disabled?: boolean;
}) => {
  const source = useMemo(
    () => (stockInfo ? 'catalog' : 'manuall'),
    [stockInfo]
  );

  const title = useMemo(() => {
    if (source === 'catalog') return 'Manual Selection';
    return 'Manual Entry';
  }, [source]);

  return (
    <Chip
      variant="outlined"
      label={title}
      color="primary"
      size="small"
      style={{
        fontWeight: 600,
        backgroundColor: disabled ? '#EEF0F2' : '#fff',
        color: disabled ? '#AFBAC6' : 'gray',
        border: `1px solid ${disabled ? '#AFBAC6' : 'gray'}`
      }}
    />
  );
};

export default ExternalChip;
